import { createAuthClient } from 'better-auth/react';

// Better-Auth client (parallel to Firebase — Phase 0 WIP).
//
// Transport mirrors the Firebase flow: the bearer plugin returns the session
// token in the `set-auth-token` response header on sign-in; we persist it and
// replay it as `Authorization: Bearer` on both auth-client calls and API calls
// (see lib/client.js). This keeps the existing bearer-token API contract.
const TOKEN_KEY = 'better-auth.session_token';

export function getSessionToken() {
  try { return localStorage.getItem(TOKEN_KEY) || ''; } catch { return ''; }
}
export function setSessionToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch { /* ignore (private mode / SSR) */ }
}
export function clearSessionToken() { setSessionToken(''); }

export const authClient = createAuthClient({
  // The better-auth server base; the client appends the /api/auth basePath.
  // REACT_APP_BACKEND_SERVER is the api origin (no /api suffix), e.g.
  // http://localhost:4000.
  baseURL: process.env.REACT_APP_BACKEND_SERVER,
  fetchOptions: {
    // Send the stored bearer token on every auth-client request.
    auth: {
      type: 'Bearer',
      token: () => getSessionToken(),
    },
    // Capture/refresh the token from any successful auth response.
    onSuccess: (ctx) => {
      const token = ctx.response.headers.get('set-auth-token');
      if (token) setSessionToken(token);
    },
  },
});
